import React from 'react'
import Vehicle from '../../../../components/customer/vehicles/vehicle/Vehicle'

const AEACustomerVehicle = () => {
    return <Vehicle />
}

export default AEACustomerVehicle
